import {Get} from "./request";
import {toast} from "react-toastify";

async function loadParameters(elm, parameterNames) {

    if (!parameterNames) {
        return;
    }

    try {
        const {body} = await Get('/v1/parameters', {
            parameterNames: parameterNames
        });

        if (!elm.state.parameters) elm.state.parameters = [];

        body.map((r) => {

            let options = [];

            r.Values.map((v) => options.push({value: Number(v.ID), label: v.Display}));

            return elm.state.parameters[r.Name] = options;
        });

    } catch (err) {

        console.log(err);

        toast.error("Le chargement des paramètres a échoué !");
    }
}

export default loadParameters;